// extracted by mini-css-extract-plugin
export default {"table_view":"SalonUsersTableView_table_view__YWK7M","action_button":"SalonUsersTableView_action_button__wZesd"};